var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("ModalFullScreen", {
        attrs: { title: _vm.modalTitle, showCustomTitle: _vm.isEdittingLocked },
        on: { close: _vm.closeModal },
        scopedSlots: _vm._u(
          [
            {
              key: "titleLine",
              fn: function () {
                return [_vm._t("customHeader", null, { title: _vm.modalTitle })]
              },
              proxy: true,
            },
            {
              key: "content",
              fn: function () {
                return [
                  _c(
                    "form",
                    { on: { submit: _vm.submit } },
                    [
                      _c("ValidationObserver", {
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ invalid, dirty, handleSubmit }) {
                              return [
                                _c(
                                  "ModalContent",
                                  {
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "actions",
                                          fn: function () {
                                            return [
                                              _c("UiButton", {
                                                staticClass: "mr-3",
                                                attrs: {
                                                  variant: "outline",
                                                  buttonText: "Cancel",
                                                },
                                                on: { click: _vm.closeModal },
                                              }),
                                              !!_vm.projectActivity
                                                ? _c("UiButton", {
                                                    attrs: {
                                                      disabled:
                                                        invalid ||
                                                        _vm.isEdittingLocked,
                                                      buttonText:
                                                        _vm.buttonText,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return handleSubmit(
                                                          _vm.submit
                                                        )
                                                      },
                                                    },
                                                  })
                                                : _c("UiButton", {
                                                    attrs: {
                                                      disabled:
                                                        invalid || !dirty,
                                                      buttonText:
                                                        _vm.buttonText,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return handleSubmit(
                                                          _vm.submit
                                                        )
                                                      },
                                                    },
                                                  }),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c("ValidationProvider", {
                                      attrs: {
                                        name: "title",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c("FormGroup", {
                                                  attrs: {
                                                    id: "title",
                                                    title: "Title*",
                                                    name: "title",
                                                    placeholder:
                                                      "Enter task title",
                                                    disabled:
                                                      _vm.isEdittingLocked,
                                                    errors: errors,
                                                  },
                                                  model: {
                                                    value: _vm.activity.title,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.activity,
                                                        "title",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "activity.title",
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    !_vm.withContractor
                                      ? _c(
                                          "FormGroup",
                                          { attrs: { title: "Contractor" } },
                                          [
                                            _c("ContractorsMultiselect", {
                                              attrs: {
                                                withBorder: false,
                                                multiple: false,
                                                contractorsConditions:
                                                  _vm.contractorsConditions,
                                                disabled: _vm.isEdittingLocked,
                                              },
                                              model: {
                                                value:
                                                  _vm.activity
                                                    .selectedContractorsIds,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.activity,
                                                    "selectedContractorsIds",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "activity.selectedContractorsIds",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.withContractor
                                      ? _c("ValidationProvider", {
                                          attrs: {
                                            name: "project",
                                            rules: "required",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({
                                                  errors,
                                                  failed,
                                                }) {
                                                  return [
                                                    _c(
                                                      "FormGroup",
                                                      {
                                                        attrs: {
                                                          title: "Project*",
                                                          errors: errors,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "ProjectsMultiselect",
                                                          {
                                                            attrs: {
                                                              single: "",
                                                              invalid: failed,
                                                              projectsConditions:
                                                                _vm.projectsConditions,
                                                              disabled:
                                                                _vm.isEdittingLocked,
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.chosenProjectId,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.chosenProjectId =
                                                                    $$v
                                                                },
                                                              expression:
                                                                "chosenProjectId",
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        })
                                      : _vm._e(),
                                    _c("ValidationProvider", {
                                      attrs: {
                                        name: "budget",
                                        rules: "decimal",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors, touched }) {
                                              return [
                                                _c(
                                                  "FormGroup",
                                                  {
                                                    attrs: {
                                                      id: "budget",
                                                      title: "Budget",
                                                      errors: touched
                                                        ? errors
                                                        : [],
                                                    },
                                                  },
                                                  [
                                                    _c("FormInputGroup", {
                                                      attrs: {
                                                        name: "budget",
                                                        placeholder:
                                                          "Enter budget",
                                                        type: "number",
                                                        inputClasses: "pl-7",
                                                        prefix: "$",
                                                        disabled:
                                                          _vm.isEdittingLocked,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.activity.budget,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.activity,
                                                            "budget",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "activity.budget",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _c(
                                      "FormGroup",
                                      { attrs: { title: "Task Description" } },
                                      [
                                        _c("FormTextarea", {
                                          attrs: {
                                            placeholder:
                                              "Describe the Client task",
                                            disabled: _vm.isEdittingLocked,
                                          },
                                          model: {
                                            value: _vm.activity.note,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.activity,
                                                "note",
                                                $$v
                                              )
                                            },
                                            expression: "activity.note",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "grid grid-cols-2 gap-4 row-gap-0 my-1",
                                      },
                                      [
                                        _c("ValidationProvider", {
                                          attrs: {
                                            vid: "start_date",
                                            name: "Start date",
                                            rules: _vm.startDateValidationRules,
                                            immediate: !!_vm.projectActivity,
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({
                                                  errors,
                                                  failed,
                                                }) {
                                                  return [
                                                    _c(
                                                      "FormGroup",
                                                      {
                                                        attrs: {
                                                          title: "Start Date*",
                                                          errors: errors,
                                                        },
                                                      },
                                                      [
                                                        _c("FormDatepicker", {
                                                          attrs: {
                                                            calendarClass:
                                                              "bottom-11",
                                                            invalid: failed,
                                                            openDate:
                                                              _vm.possibleStartDate,
                                                            disabledDates:
                                                              _vm.activityDisabledDates,
                                                            disabled:
                                                              _vm.isEdittingLocked,
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.activity
                                                                .startDate,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.activity,
                                                                "startDate",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "activity.startDate",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                        _c("ValidationProvider", {
                                          attrs: {
                                            vid: "end_date",
                                            name: "End date",
                                            rules: _vm.endDateValidationRules,
                                            immediate: !!_vm.projectActivity,
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({
                                                  errors,
                                                  failed,
                                                }) {
                                                  return [
                                                    _c(
                                                      "FormGroup",
                                                      {
                                                        attrs: {
                                                          title: "End Date*",
                                                          errors: errors,
                                                        },
                                                      },
                                                      [
                                                        _c("FormDatepicker", {
                                                          attrs: {
                                                            calendarClass:
                                                              "right-0 bottom-11",
                                                            invalid: failed,
                                                            openDate:
                                                              _vm.possibleEndDate,
                                                            disabledDates:
                                                              _vm.activityDisabledDates,
                                                            disabled:
                                                              _vm.isEdittingLocked,
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.activity
                                                                .endDate,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.activity,
                                                                "endDate",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "activity.endDate",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                        !_vm.projectActivity
                                          ? _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "col-span-2 mb-2 ml-1 text-sm text-gray-700",
                                              },
                                              [
                                                _vm._v(
                                                  " Please, fill in approximate start and end dates. You can always change them later. "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _c("ValidationProvider", {
                                      attrs: {
                                        name: "Task Hours",
                                        rules:
                                          "min_value:1|max_value:1000000000|integer|required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c("FormGroup", {
                                                  staticClass: "mb-4",
                                                  attrs: {
                                                    title: "Task Hours*",
                                                    type: "number",
                                                    placeholder:
                                                      "Enter task hours",
                                                    disabled:
                                                      _vm.isEdittingLocked,
                                                    errors: errors,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.activity
                                                        .confirmedHours,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.activity,
                                                        "confirmedHours",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "activity.confirmedHours",
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }